<script setup lang="ts">
import { EditTripStepType } from '@apps/main/new-desktop/modules/editTripModal';
import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import { AppButton } from '@libs/ui';

import { useTripOverviewModalsStore } from '../../stores/tripOverviewModalsStore';

const tripOverviewModalsStore = useTripOverviewModalsStore();
const statsigEventsStore = useStatsigEventsStore();

function openDestinationModal(): void {
  statsigEventsStore.logTripOverviewAddDestinationClicked();
  tripOverviewModalsStore.openEditTripModal({
    stepType: EditTripStepType.AddDestination,
  });
}
</script>

<template>
  <button class="add-destination-button" @click="openDestinationModal">
    <AppButton
      class="plus-button"
      type="secondary"
      state="enabled"
      size="medium"
      :icon="{ name: 'plus' }"
    >
      {{ $t('planner.add_destination') }}
    </AppButton>
  </button>
</template>

<style scoped lang="scss">
.add-destination-button {
  width: fit-content;
  display: flex;
  gap: var(--spacing-8);
  cursor: pointer;
  align-items: center;
  padding-left: var(--spacing-24);

  @include for-less-or-equal-than-599-px {
    padding-left: var(--spacing-12);
  }

  .plus-button {
    padding-left: var(--spacing-4);
  }
}
</style>
